import { usePaginationSize } from "@/hooks/use-pagination-size";

export function useTableDefaultPageSize(options?: { minRows?: number; maxRows?: number }) {
  const defaultSize = usePaginationSize({
    minRows: options?.minRows ?? 5,
    maxRows: options?.maxRows ?? 50,
    estimatedRowHeight: 50,
    uiOverheadHeight: 270,
    paginationHeight: 64,
  });

  return defaultSize;
}
